import React from "react";
import Tr from "./Tr"; // Importing the Tr component to render table rows

export default function Table({ data, onApprove }) {
  return (
    <div className="form-container">
      {/* Main table structure */}
      <table className="table">
        <thead>
          <tr>
            {/* Table header cells */}
            <th className="ps-5">Art Pack Name</th>            
            <th className="ps-5">Campaign</th>
            <th className="ps-5 center-text">Percentage</th>
            <th className="ps-5 center-text">Action</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (  // Conditional rendering based on data length
            <tr>
              {/* Message displayed when there is no data */}
              <td className="ps-5" colSpan={4}>no sponsors yet!....</td>
            </tr>
          ) : (
            // Mapping through the data array to create a row for each entry
            data.map((d, index) => (
              <Tr
                key={index}  // Using index as a key (consider using a unique identifier if available)
                identi={d.approved_campaign_id}  // Passing various properties to the Tr component
                campaign_id={d.campaign_id}
                art_pack_name={d.art_pack_name}
                min_percentage={d.min_artist_percentage}
                approved={d.approved}
                campaign_name={d.campaign_name}
                onApprove={onApprove}  // Function to handle edit actions
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
